// components/SubMenu.styles.ts

import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  root: {
    backgroundColor: '#000',
    color: '#fff',
    px: 2,
  },
  toolbar: {
    justifyContent: 'space-between',
    minHeight: 40,
    height: 40,
  },
  linksBox: {
    display: 'flex',
    alignItems: 'center',
  },
  menuButton: {
    mr: 2,
  },
  link: {
    color: '#fff',
    mr: 3,
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  drawer: {
    width: 250,
  },
};
